/**
 * The type of the product dictates it's availability
 * The following mapping is used:
 * 0: Assortiment (assortment)
 * 1: Voorraad (stock)
 * 2: Prijslijsten (pricelist)
 * 3: Leverhistorie (delivery history)
 * 4: Orderhistorie (order history)
 * 5: Uitverkochte Partij (Sold out / not available)
 *
 * @author Patrick van Zadel
 */
export enum ProductTypes {
  ASSORTMENT,
  STOCK,
  PRICELIST,
  DELIVERY_HISTORY,
  ORDER_HISTORY,
  SOLD_OUT,
}
